import { CartScheduleSlot } from '@/types/cart.types';
import { dateFormatter } from '@/utils/formatters/date';

export const BRASILIA_TIME_LABEL = '(horário de Brasília)';

export function formatCartItemSchedule(slot: CartScheduleSlot): string {
  if (!slot.start || Number.isNaN(new Date(slot.start).getTime())) {
    return '';
  }

  const formatted = dateFormatter(slot.start, 'DD/MM/YYYY [às] HH:mm');

  if (!formatted) {
    return '';
  }

  return `${formatted} ${BRASILIA_TIME_LABEL}`;
}
